module.exports = __webpack_public_path__ + "static/media/MSungHK-Medium.1fd3bbde.svg";